export const INNER_BORDER_COLOR = "#000000";
export const INNER_BORDER_WIDTH = 0.25;
export const HEADER_COLOR = '#D3D3D3';

export const PAGE_BORDER_WIDTH = 5;
export const FULL_WIDTH = 216 - (PAGE_BORDER_WIDTH * 2);
export const TABLE_ROWS = 8;
export const TABLE_HEIGHT = 70;
export const CONVERT_TO_PIXEL = 3.7795275591;
export const OFFSET = 5;


// WEBPACK FOOTER //
// ./src/Services/Pdf/WellStoryReport/SpecMilsWellStory.ts